package com.example.mystybag.common.views

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import dev.icerock.moko.resources.compose.painterResource
import dev.icerock.moko.resources.compose.stringResource
import com.example.mystybag.common.resources.SR
import com.example.mystybag.common.extensions.roundedContainer
import com.example.mystybag.common.logic.InternetTroubleshootingViewModel
import com.example.mystybag.core.resources.SRC
import com.example.mystybag.common.ui.components.custom.IconText
import com.example.mystybag.common.ui.components.native.DefaultButton
import com.example.mystybag.common.ui.components.native.Texts
import com.example.mystybag.common.ui.components.native.Texts.ClickableTextView
import com.example.mystybag.core.ui.theme.LocalTheme.p12
import com.example.mystybag.core.ui.theme.LocalTheme.p16
import com.example.mystybag.core.ui.theme.LocalTheme.p20
import com.example.mystybag.core.ui.theme.LocalTheme.p24
import com.example.mystybag.core.ui.theme.LocalTheme.p8
import com.example.mystybag.core.views.AppTheme
import com.example.mystybag.common.ui.views.UIView

@Composable
fun InternetTroubleshootingView(viewModel: InternetTroubleshootingViewModel) {
    UIView(viewModel, modifier = Modifier.padding(horizontal = p16)) { state ->
        Column(
            modifier            = Modifier
                .fillMaxWidth()
                .weight(1f)
                .verticalScroll(rememberScrollState()),
            horizontalAlignment = Alignment.Start,
            verticalArrangement = Arrangement.spacedBy(p16)
        ) {
            Texts.HeadlineMedium(
                text        = stringResource(SR.strings.what_can_i_do_title),
                modifier    = Modifier.fillMaxWidth(),
                textAlign   = TextAlign.Center
            )
            Texts.TitleSmall(
                modifier    = Modifier.padding(top = p20),
                text        = stringResource(SR.strings.possible_reasons)
            )

            Column(
                modifier            = Modifier
                    .fillMaxWidth()
                    .roundedContainer(padding = p16, background = AppTheme.current.colors.surface),
                horizontalAlignment = Alignment.Start,
                verticalArrangement = Arrangement.spacedBy(p20)
            ) {
                IconText(
                    icon     = painterResource(SRC.images.ic_internet_connection_icon),
                    text     = stringResource(SR.strings.your_internet_connection_is_not_strong_enough),
                    iconSize = p20,
                    divider  = false
                )
                IconText(
                    icon     = painterResource(SRC.images.ic_disabled_wi_fi_icon),
                    text     = stringResource(SR.strings.you_have_turned_off_your_wifi_or_mobile_data),
                    iconSize = p20,
                    divider  = false
                )
                IconText(
                    icon     = painterResource(SRC.images.ic_airplane_icon),
                    text     = stringResource(SR.strings.your_phone_is_in_plane_mode),
                    iconSize = p20,
                    divider  = false
                )
                IconText(
                    icon     = painterResource(SRC.images.ic_phone_settings_icon),
                    text     = stringResource(SR.strings.the_app_cannot_establish_a_secure_connection_with_our_servers),
                    iconSize = p20,
                    divider  = false
                )
            }

            Texts.TitleSmall(
                modifier    = Modifier.padding(top = p16),
                text        = stringResource(SR.strings.what_can_i_do)
            )

            Column(
                modifier            = Modifier.roundedContainer(padding = p16, background = AppTheme.current.colors.surface),
                verticalArrangement = Arrangement.spacedBy(p8)
            ) {
                Texts.BodyLarge(text = stringResource(SR.strings.check_for_app_updates))
                Texts.BodyMedium(stringResource(SR.strings.make_sure_you_re_using_the_latest_version_of_the_app))

                Texts.BodyLarge(
                    modifier    = Modifier.padding(top = p8),
                    text        = stringResource(SR.strings.check_your_internet_connection)
                )
                Texts.BodyMedium(stringResource(SR.strings.try_using_mystybag_both_on_wifi_and_on_your_mobile_data_connection))

                Texts.BodyLarge(
                    modifier    = Modifier.padding(top = p8),
                    text        = stringResource(SR.strings.restart_your_phone)
                )
                Texts.BodyMedium(stringResource(SR.strings.try_restarting_your_phone_it_may_help_to_clear_your_cash_and_data_leaks))

                Texts.BodyLarge(
                    modifier    = Modifier.padding(top = p8),
                    text        = stringResource(SR.strings.reinstall_the_app)
                )
                Texts.BodyMedium(stringResource(SR.strings.if_restarting_your_device_and_checking_your_connection_do_not_help))
            }
        }

        ClickableTextView(
            texts       = state.value.issueText,
            textAlign   = TextAlign.Center,
            textStyle   = AppTheme.current.typography.bodyLarge,
            modifier    = Modifier.padding(vertical = p24),
            onItemClick = { viewModel.onContactUsClicked() }
        )

        DefaultButton(
            caption     = stringResource(SR.strings.ok),
            modifier    = Modifier.padding(bottom = p12),
            callback    = viewModel::goBack
        )
    }
}